import axios from "axios";

// Friendly labels for the role keys.
// Keys without an entry here fall back to the raw key.
const ROLE_LABELS = {
  Administrator: "Administrator",
  RD: "Regional Director",
  Chief: "Chief",
  Supervisor: "Supervisor",
  NstpCoordinator: "NSTP Coordinator",
  NstpFocal: "NSTP Focal",
  President: "President",
  Records: "Records",
  admin: "Budget Admin",
  accounting: "Accounting",
  COS: "Contract of Service",
  Regular: "Regular Employee",
  planting_trees: "Planting Trees",
  planting_trees_admin: "Planting Trees Admin",
  supply_officer: "Supply Officer",
  HR: "Human Resources",
  inventory_authorize: "Inventory",
  HRMPSB: "HRMPSB",
  Registrar: "Registrar",
};

// Role values shown in the User Management dropdown, in display order.
const ROLE_VALUES = [
  "Administrator",
  "COS",
  "Chief",
  "HR",
  "NstpCoordinator",
  "NstpFocal",
  "President",
  "RD",
  "Records",
  "Registrar",
  "Supervisor",
  "planting_trees",
];

export function roleLabel(key) {
  if (!key) return "—";
  return ROLE_LABELS[key] || key;
}

// Static fallback used only if the roles API is unreachable.
export const roleOptions = ROLE_VALUES.map((value) => ({
  value,
  label: roleLabel(value),
}));

/**
 * Role options for the User Management dropdown, sourced from the Roles &
 * Permissions module (GET /api/roles) so newly created roles appear and removed
 * ones disappear automatically. Friendly labels from ROLE_LABELS are applied as
 * overrides; falls back to the static list if the request fails.
 */
export async function fetchRoleOptions() {
  try {
    const { data } = await axios.get("api/roles");
    if (Array.isArray(data) && data.length) {
      return data
        .map((role) => ({
          value: role.slug,
          label: ROLE_LABELS[role.slug] || role.name || role.slug,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    }
  } catch (e) {
    // ignore and use the static fallback below
  }
  return roleOptions;
}

/**
 * Active job positions for the User Management dropdown, sourced from
 * GET /api/positions. Returns [{ value: id, label, salaryGrade }]. Falls back
 * to an empty list if the request fails (the field then shows "no positions").
 */
export async function fetchPositionOptions() {
  try {
    const { data } = await axios.get("api/positions", {
      params: { active_only: 1 },
    });
    if (Array.isArray(data)) {
      return data
        .map((p) => ({
          value: p.id,
          label: p.title,
          salaryGrade: p.salary_grade,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    }
  } catch (e) {
    // ignore and fall through to the empty list
  }
  return [];
}
